import React from 'react'
import 'styles/d3/popup.scss'

class Popup extends React.Component {
  constructor(props) {
    super(props)
    this.state = { open: false }
  }

  componentWillMount() {
    this.listener = e => {
      if (!this.refs.thisComponent.contains(e.target)) {
        this.onTrigger(false)
      }
    }
    document.addEventListener('click', this.listener)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.listener)
  }

  onTrigger = (open = !this.state.open) => {
    if (this.props.disabled) return
    if (this.props.onOpen && open) {
      this.props.onOpen()
    }
    if (this.props.onClose && !open) {
      this.props.onClose()
    }
    this.setState({ open })
  }

  onClickContent = e => {
    if (!e.target.classList.contains('close-trigger')) {
      e.stopPropagation()
    }
  }

  render() {
    const {
      children,
      trigger,
      position = 'bottom',
      hover,
      open = this.state.open,
      color,
      className = '',
      align,
      noPointer,
      disabled
    } = this.props
    let popupClass = 'popup ' + position
    let containerClass = 'popup-container' + (className ? ` ${className}` : '')
    containerClass += open ? ' open' : ''
    containerClass += disabled ? ' disabled' : ''
    containerClass += ` ${position}`
    popupClass += open ? '' : ' hidden'
    popupClass += noPointer ? ' no-pointer' : ''
    popupClass += align === 'left' ? ' align left-align' : align === 'right' ? ' align right-align' : ''
    return (
      <div
        ref='thisComponent'
        onMouseEnter={hover ? () => this.onTrigger(true) : null}
        onMouseLeave={hover ? () => this.onTrigger(false) : null}
        onClick={
          hover
            ? null
            : e => {
                e.stopPropagation()
                this.onTrigger()
              }
        }
        className={containerClass}>
        {trigger}
        {!disabled && children ? (
          <div onClick={this.onClickContent} className={popupClass}>
            {children}
          </div>
        ) : null}
      </div>
    )
  }
}

export default Popup



// WEBPACK FOOTER //
// ./src/components/Popup.js